import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useCallback, useEffect, useMemo, useState } from 'react';
import { SubmissionScore } from '@module/assignment';
import styled from '@xstyled/styled-components';
import { AudioPlayer, styleVariables, TextAreaBox, EditorCommentViewOnly, EditorComment } from '@lib/common';
import { Button, Space, Tooltip } from 'antd';
import { GradingBaseAnswer } from './base-question.component';
import { CommentBox, CommentPreview } from '../../submission-preview';
import { EditOutlined } from '@ant-design/icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SpaceContainer = styled(Space)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
var AudioPlayerContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-top: ", ";\n"])), styleVariables.margin.small);
var CommentHeaderSpace = styled(Space)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n"])));
var CommentTitle = styled.label(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: ", ";\n  color: ", ";\n"])), styleVariables.font.fontSizeOriginal, styleVariables.font.fontWeightStrong, styleVariables.colors.gray13);
var EditorSection = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  margin-top: ", ";\n  padding-top: ", ";\n  border-top: 1px solid ", ";\n"])), styleVariables.margin.medium, styleVariables.padding.medium, styleVariables.colors.gray8);
var StudentWorkHeader = styled(Space)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n"])));
var SectionLabel = styled.label(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: ", ";\n"])), styleVariables.font.fontSizeSmall, styleVariables.font.fontWeightStrong);
var EmptyAnswerLabel = styled.label(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: ", ";\n  color: ", ";\n  font-style: italic;\n"])), styleVariables.font.fontSizeSmall, styleVariables.font.fontWeightNormal, function (props) {
  return props.theme.color.textSupport;
});
var AnswerContainer = styled(Space)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  width: 100%;\n"])));

var isAnswerGraded = function isAnswerGraded(answer) {
  return answer.score !== SubmissionScore["default"].value;
};

var canEditComment = function canEditComment(isAssignmentEnded, disabled, isOnGradingProcess) {
  return isAssignmentEnded && !disabled && !isOnGradingProcess;
};

var countWords = function countWords(text) {
  var cleanedText = text.replace(/<[^>]*>/g, ' ');
  var clearSpaceText = cleanedText.trim();

  if (!clearSpaceText) {
    return 0;
  }

  var words = clearSpaceText.split(/\s+/);
  return words.length;
};

export var GradingEssayAnswer = function GradingEssayAnswer(_ref) {
  var _answer$value5;

  var question = _ref.question,
      isSkipped = _ref.isSkipped,
      answer = _ref.answer,
      isPreviewMode = _ref.isPreviewMode,
      label = _ref.label,
      isAssignmentEnded = _ref.isAssignmentEnded,
      disabled = _ref.disabled,
      index = _ref.index,
      onComment = _ref.onComment,
      onAnswerComment = _ref.onAnswerComment,
      onUpdateAnswerComment = _ref.onUpdateAnswerComment,
      onDeleteAnswerComment = _ref.onDeleteAnswerComment,
      isCommentLoading = _ref.isCommentLoading,
      isOnGradingProcess = _ref.isOnGradingProcess,
      _ref$comments = _ref.comments,
      comments = _ref$comments === void 0 ? [] : _ref$comments,
      setComments = _ref.setComments,
      onClickAnswer = _ref.onClickAnswer,
      submitGradeAnswer = _ref.submitGradeAnswer,
      scoreValue = _ref.value,
      isShowingExplanation = _ref.isShowingExplanation;

  var _useState = useState(false),
      isCommentEditing = _useState[0],
      setIsCommentEditing = _useState[1];

  var commentPreviewLabel = useMemo(function () {
    return {
      noContent: label.noComment,
      seeMore: label.seeMore,
      seeLess: label.seeLess
    };
  }, [label.noComment, label.seeMore, label.seeLess]);
  var editorCommentLabels = useMemo(function () {
    return {
      save: label.save,
      cancel: label.cancel,
      comment: label.comment,
      selectColor: label.selectColor
    };
  }, [label.save, label.cancel, label.comment, label.selectColor]);
  useEffect(function () {
    if (!isCommentLoading) {
      setIsCommentEditing(false);
    }
  }, [isCommentLoading]);
  var handleCancelComment = useCallback(function () {
    setIsCommentEditing(false);
  }, []);
  var handleSaveComment = useCallback(function (textValue) {
    onComment === null || onComment === void 0 ? void 0 : onComment(textValue);
    setIsCommentEditing(false);
  }, [onComment]);
  var handleEditClick = useCallback(function () {
    if (!disabled) {
      setIsCommentEditing(true);
    }
  }, [disabled]);
  var handleClickAnswer = useCallback(function () {
    if (onClickAnswer && answer !== null && answer !== void 0 && answer.id) {
      onClickAnswer(answer.id.toString());
    }
  }, [onClickAnswer, answer === null || answer === void 0 ? void 0 : answer.id]);

  var renderCommentEditor = function renderCommentEditor() {
    return /*#__PURE__*/_jsx(CommentBox, {
      label: _objectSpread(_objectSpread({}, label), {}, {
        placeholder: label.enterComment
      }),
      onSave: handleSaveComment,
      value: answer === null || answer === void 0 ? void 0 : answer.comment,
      onCancel: handleCancelComment,
      loading: isCommentLoading || disabled
    });
  };

  var renderEmptyComment = function renderEmptyComment() {
    var canEdit = canEditComment(isAssignmentEnded, disabled, isOnGradingProcess);
    return /*#__PURE__*/_jsx(Tooltip, {
      title: canEdit ? undefined : label.disabledText,
      children: /*#__PURE__*/_jsx(TextAreaBox, {
        placeholder: label.enterComment,
        onClick: canEdit ? handleEditClick : undefined,
        disabled: !canEdit
      })
    });
  };

  var renderComment = function renderComment() {
    if (isPreviewMode || disabled) {
      return /*#__PURE__*/_jsx(CommentPreview, {
        value: answer !== null && answer !== void 0 && answer.isEmptyComment() ? '' : answer === null || answer === void 0 ? void 0 : answer.comment,
        label: commentPreviewLabel
      });
    }

    if (isCommentEditing) {
      return renderCommentEditor();
    }

    if (answer !== null && answer !== void 0 && answer.isEmptyComment()) {
      return renderEmptyComment();
    }

    return /*#__PURE__*/_jsx(CommentPreview, {
      value: answer === null || answer === void 0 ? void 0 : answer.comment,
      label: commentPreviewLabel
    });
  };

  var renderAnswer = function renderAnswer() {
    var _answer$answerComment, _answer$value, _answer$answerComment2, _answer$answerComment3, _answer$answerComment4, _answer$answerComment5, _answer$value3, _answer$value4;

    if (answer !== null && answer !== void 0 && answer.isEmpty()) {
      return /*#__PURE__*/_jsx(EmptyAnswerLabel, {
        children: "[".concat(label.noAnswer, "]")
      });
    }

    var answerContent = (answer === null || answer === void 0 ? void 0 : (_answer$answerComment = answer.answerComment) === null || _answer$answerComment === void 0 ? void 0 : _answer$answerComment.submissionAnswerContent) || (answer === null || answer === void 0 ? void 0 : (_answer$value = answer.value) === null || _answer$value === void 0 ? void 0 : _answer$value.text);

    if (onAnswerComment && onUpdateAnswerComment && onDeleteAnswerComment && setComments) {
      var _answer$value2;

      return /*#__PURE__*/_jsxs(AnswerContainer, {
        direction: "vertical",
        onClick: handleClickAnswer,
        children: [/*#__PURE__*/_jsx(EditorComment, {
          onAnswerComment: onAnswerComment,
          content: answerContent,
          onUpdateAnswerComment: onUpdateAnswerComment,
          onDeleteAnswerComment: onDeleteAnswerComment,
          showComment: true,
          comments: comments,
          setComments: setComments,
          labels: editorCommentLabels
        }), (answer === null || answer === void 0 ? void 0 : (_answer$value2 = answer.value) === null || _answer$value2 === void 0 ? void 0 : _answer$value2.audioFile) && /*#__PURE__*/_jsx(AudioPlayer, {
          source: answer.value.audioFile.url
        })]
      });
    }

    return /*#__PURE__*/_jsxs(AnswerContainer, {
      direction: "vertical",
      children: [(answer === null || answer === void 0 ? void 0 : (_answer$answerComment2 = answer.answerComment) === null || _answer$answerComment2 === void 0 ? void 0 : _answer$answerComment2.submissionAnswerContent) && /*#__PURE__*/_jsx(EditorSection, {
        children: /*#__PURE__*/_jsx(EditorCommentViewOnly, {
          content: answer.answerComment.submissionAnswerContent,
          comments: (answer === null || answer === void 0 ? void 0 : (_answer$answerComment3 = answer.answerComment) === null || _answer$answerComment3 === void 0 ? void 0 : (_answer$answerComment4 = _answer$answerComment3.comments) === null || _answer$answerComment4 === void 0 ? void 0 : _answer$answerComment4.map(function (comment) {
            return {
              id: comment.id.toString(),
              content: comment.content
            };
          })) || [],
          scrollable: true,
          labels: {
            comment: label.comment
          }
        })
      }), !(answer !== null && answer !== void 0 && (_answer$answerComment5 = answer.answerComment) !== null && _answer$answerComment5 !== void 0 && _answer$answerComment5.submissionAnswerContent) && (answer === null || answer === void 0 ? void 0 : (_answer$value3 = answer.value) === null || _answer$value3 === void 0 ? void 0 : _answer$value3.text) && /*#__PURE__*/_jsx(EditorSection, {
        children: /*#__PURE__*/_jsx(EditorCommentViewOnly, {
          content: answer.value.text,
          comments: [],
          scrollable: true,
          labels: {
            comment: label.comment
          }
        })
      }), (answer === null || answer === void 0 ? void 0 : (_answer$value4 = answer.value) === null || _answer$value4 === void 0 ? void 0 : _answer$value4.audioFile) && /*#__PURE__*/_jsx(AudioPlayerContainer, {
        children: /*#__PURE__*/_jsx(AudioPlayer, {
          source: answer.value.audioFile.url
        })
      })]
    });
  };

  var shouldShowEditButton = !isCommentEditing && !(answer !== null && answer !== void 0 && answer.isEmptyComment()) && !isPreviewMode && !disabled;
  var wordCount = answer !== null && answer !== void 0 && (_answer$value5 = answer.value) !== null && _answer$value5 !== void 0 && _answer$value5.text ? countWords(answer.value.text) : 0;
  return /*#__PURE__*/_jsx(GradingBaseAnswer, {
    question: question,
    label: label,
    value: scoreValue,
    isSkipped: isSkipped,
    submitGradeAnswer: submitGradeAnswer,
    isEssayQuestion: true,
    disabled: disabled,
    isAllQuestionAnswersGraded: isAnswerGraded(answer),
    isShowingExplanation: isShowingExplanation,
    index: index,
    children: /*#__PURE__*/_jsxs(SpaceContainer, {
      direction: "vertical",
      children: [/*#__PURE__*/_jsxs(StudentWorkHeader, {
        children: [/*#__PURE__*/_jsx(SectionLabel, {
          children: label.studentWork
        }), wordCount > 0 && /*#__PURE__*/_jsxs(SectionLabel, {
          children: [wordCount, " ", label.word]
        })]
      }), renderAnswer(), /*#__PURE__*/_jsxs(CommentHeaderSpace, {
        children: [/*#__PURE__*/_jsx(CommentTitle, {
          children: label.teacherComment
        }), shouldShowEditButton && /*#__PURE__*/_jsx(Button, {
          icon: /*#__PURE__*/_jsx(EditOutlined, {}),
          type: "text",
          shape: "circle",
          onClick: handleEditClick,
          disabled: disabled,
          loading: isCommentLoading
        })]
      }), renderComment()]
    })
  });
};